module.exports = __webpack_public_path__ + "static/media/rebeca.2700ddef.jpg";